import { useEffect, useState } from 'react'

import { PhnxAvatar } from '@/components/01-atoms/Avatar/Avatar'
import { PhnxHerobanner } from '@/components/02-molecules/Herobanner/Herobanner'
import { storyHref } from '@/utils/url'

import styles from './Sidenavtemplate.module.css'

export type NavItemProps = {
  title: string
  link: string
  target: '_self' | '_blank'
  currentPath?: boolean
}

export type SidenavtemplateProps = {
  variant?: 'primary' | 'secondary'
  image?: {
    src: string
    alt: string
    focus: string
  }
  herobanner?: {
    video_id?: number
    asset?: {
      src: string
      alt: string
      focus?: string
    }
  }
  title?: string
  description?: string
  nav?: NavItemProps[]
  content?: React.ReactNode
  teamMembers?: any[]
}

export const PhnxSidenavtemplate: React.FC<SidenavtemplateProps> = ({
  variant = 'primary',
  title,
  description,
  image,
  herobanner,
  nav,
  content,
  teamMembers,
}) => {
  const [imageUri, setImageUri] = useState<string>('')

  useEffect(() => {
    if (image?.src) {
      const imageHeightWidth = '1800x561'
      let imageUri = `${image.src}/m/${imageHeightWidth}/filters:quality(100)`

      if (image?.focus) {
        imageUri = `${imageUri}:focal(${image.focus})`
      }
      setImageUri(imageUri)
    }
  }, [image])

  return (
    <div className={styles['sidenavtemplate']}>
      {herobanner?.video_id && (
        <PhnxHerobanner video={{ id: herobanner.video_id }} layout="default" cropImage={true} />
      )}
      {herobanner?.asset?.src && !herobanner?.video_id && (
        <PhnxHerobanner asset={herobanner.asset} layout="default" cropImage={true} />
      )}
      {!herobanner?.video_id && !herobanner?.asset?.src && image?.src && (
        <div
          className={styles['feature-image']}
          style={{
            backgroundImage: `url("${imageUri}")`,
          }}
        ></div>
      )}

      <div className={`${styles['sidenav-container']} container`}>
        <div className={styles['sidenav-nav']}>
          <ul>
            {nav &&
              nav.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.link}
                    target={item.target}
                    className={`${styles[item.currentPath ? 'sidenav-item-selected' : 'sidenav-item']}`}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
          </ul>
        </div>
        <div className={styles['sidenav-details']}>
          <div className={styles['sidenav-header']} id="sidenav-header">
            {title && <h1 className={styles['sidenav-title']}>{title}</h1>}
            {description && <p className={styles['sidenav-description']}>{description}</p>}
          </div>
          <div className={styles['sidenav-content']} id="sidenav-content">
            {variant === 'primary' && content && <div className={styles['content']}>{content}</div>}
            {variant === 'secondary' && content && (
              <div className={styles['content-grid']} id="content-grid">
                {teamMembers && teamMembers.length > 0 && (
                  <>
                    {teamMembers.map((member, index) => (
                      <PhnxAvatar
                        key={index}
                        title={member.name}
                        subtitle={member.content.role}
                        asset={{
                          src: member.content.photo.filename ? member.content.photo.filename : '',
                          alt: member.content.photo.alt,
                        }}
                        link={storyHref(member.full_slug)}
                        size="default"
                        style="feature"
                      />
                    ))}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
